import { GlobalWorkerOptions } from 'pdfjs-dist';

/**
 * Configures PDF.js to load its worker script as a real dedicated Worker.
 *
 * The PDF worker is exposed by the shell application (web.shell) and resolved via `document.baseURI`, consistent with
 * how lookup-search.worker is exposed. This ensures the worker is available at the host page's origin regardless of
 * which remote micro-app is requesting it.
 *
 * This is a side-effect-only module: importing it once is enough to configure the worker for every
 * `pdfjsLib.getDocument(...)` call made through `HxPdfViewer`.
 */
GlobalWorkerOptions.workerSrc = new URL('assets/pdf.worker.min.mjs', document.baseURI).href;
